import { useTranslation } from 'react-i18next';
import { HrmManagement } from './HrmManagement';
import { HrmIntegratedManagement } from './HrmIntegratedManagement';
import { HrmSignupCard } from './HrmSignupCard';

export default function HrmDetails() {
    const { t } = useTranslation();

    return (
        <div className="mt-[86px] mainContainer">
            <div className="flex flex-col gap-10">
                <HrmManagement
                    icon="recruitment"
                    title={t('hrMangementPage.details.recruitment.title')}
                    description={t('hrMangementPage.details.recruitment.description')}
                />
                <HrmIntegratedManagement
                    icon="attendance"
                    title={t('hrMangementPage.details.attendance.title')}
                    description={t('hrMangementPage.details.attendance.description')}
                />

                <HrmManagement
                    icon="performance"
                    title={t('hrMangementPage.details.performance.title')}
                    description={t('hrMangementPage.details.performance.description')}
                />
                <HrmIntegratedManagement
                    title={t('hrMangementPage.details.contracts.title')}
                    description={t('hrMangementPage.details.contracts.description')}
                />
                <HrmManagement
                    icon="interface"
                    title={t('hrMangementPage.details.shifts.title')}
                    description={t('hrMangementPage.details.shifts.description')}
                />
            </div>
            <HrmSignupCard />
        </div>
    );
}
